import type {
  DigitalProofingAndArtworkFormProps,
  DigitalProofingReduxState
} from './DigitalProofingAndArtworkForm.types'
import { connect } from 'react-redux'
import { Button } from 'reactstrap'
import { fetchAddressesByPortalConfig, dispatchSweetAlert, clearSweetAlert } from '../../../actions'
import { updateDigitalProofingSelection } from '../productPageFunctions'
import ArtworkDropdown from './ArtworkDropdown'
import ArtworkOverlayGroupControls from './ArtworkOverlayGroupControls'
import DigitalProofingFormDynamic from './DigitalProofingFormDynamic'
import ProofPreviewModal from './ProofPreviewModal'
import PublishSocialModal from './PublishSocialModal'
import { useDigitalProofingAndArtworkForm } from './useDigitalProofingAndArtworkForm'

export const DigitalProofingAndArtworkForm = (props: DigitalProofingAndArtworkFormProps) => {
  const { product, isBundleProduct, selectedArtwork, portal } = props
  const proofingForm = useDigitalProofingAndArtworkForm(props)
  const isSocialProduct = !!product.is_social || !!product.flags?.is_social

  if (!product.product_id) return <p>No product</p>

  return (
    <div className={isBundleProduct ? 'description-container mf-m-0 mf-p-0' : 'description-container'}>
      <ArtworkDropdown
        product={product}
        artworks={proofingForm.artworks}
        selectedArtwork={selectedArtwork}
        selectedArtworkId={proofingForm.selectedArtworkId}
        isDigitalProofingProduct={proofingForm.isDigitalProofingProduct}
        onSelectArtwork={proofingForm.setSelectedArtworkId}
      />

      <ArtworkOverlayGroupControls
        isDigitalProofingProduct={proofingForm.isDigitalProofingProduct}
        selectedArtwork={selectedArtwork}
        visibleOverlayGroups={proofingForm.visibleOverlayGroups}
        selectedOverlayIdsByGroup={proofingForm.selectedOverlayIdsByGroup}
        overlayOptionsById={proofingForm.overlayOptionsById}
        onSelectOverlayGroup={proofingForm.handleSelectOverlayGroup}
        onToggleOverlayGroupOption={proofingForm.handleToggleOverlayGroupOption}
      />

      <div className={selectedArtwork ? 'mf-mb-20 mf-mt-20' : 'd-none'}>
        <div style={{ textAlign: 'right' }}>
          {proofingForm.artworks.length > 1 || proofingForm.visibleOverlayGroups.length > 0 ? (
            <Button className="btn mf-warning-btn" onClick={proofingForm.resetAllSelections}>
              Reset My Selections
            </Button>
          ) : null}
        </div>

        {selectedArtwork && proofingForm.isDigitalProofingProduct ? (
          <DigitalProofingFormDynamic
            artwork={selectedArtwork}
            complete={proofingForm.formComplete}
            hasRenderingCoupon={proofingForm.hasRenderingCoupon}
            overlayGroupsValid={proofingForm.overlayGroupsValid}
            selectedArtworkOverlayIds={proofingForm.selectedArtworkOverlayIds}
            onValuesChange={proofingForm.setDynamicFieldValues}
          />
        ) : (
          <h5></h5>
        )}
      </div>

      <ProofPreviewModal
        isOpen={proofingForm.showProofModal}
        previewFailed={proofingForm.previewFailed}
        previewLoading={proofingForm.previewLoading}
        previewErrorMessage={proofingForm.previewErrorMessage}
        proofPreview={proofingForm.proofPreview}
        isGeneratingProof={proofingForm.isGeneratingProof}
        isAddingToCart={proofingForm.isAddingToCart}
        proof1={proofingForm.proof1}
        proof2={proofingForm.proof2}
        isBundleProduct={isBundleProduct}
        isSocialProduct={isSocialProduct}
        portal={portal}
        onCancel={proofingForm.cancelProof}
        onDownloadProofPreview={proofingForm.downloadProofPreview}
        onRetry={proofingForm.retryPreview}
        onToggleProof={proofingForm.toggleProof}
        onApprove={proofingForm.handleAddProduct}
        onPublish={proofingForm.openPublishModal}
      />

      <PublishSocialModal
        open={proofingForm.publishModalOpen}
        onOpenChange={proofingForm.handlePublishModalOpenChange}
        productId={isBundleProduct ? product.product_id : product.id}
        digitalProofingProductId={proofingForm.proofingPreviewId!}
        previewUrl={proofingForm.proofPreview?.url}
        defaultSocialCaption={product.default_social_caption}
        onPublished={proofingForm.handlePublishSuccess}
      />
    </div>
  )
}

const mapStateToProps = (state: DigitalProofingReduxState) => {
  return {
    portal: state.portal,
    customer_addresses: Object.values(state.customer_addresses).filter(address => address.address_type === 'delivery'),
    customerGroup: state.customerGroup,
    currentUser: state.currentUser
  }
}

export default connect(mapStateToProps, {
  fetchAddressesByPortalConfig,
  updateDigitalProofingSelection,
  dispatchSweetAlert,
  clearSweetAlert
})(DigitalProofingAndArtworkForm)
